// @flow

import React from 'react';
import bemify from 'bemify-js';

import 'app/common/components/AbbreviatedNumber.scss';

const bem = bemify('abbreviated-number');

type AbbreviatedNumberProps = {
  maxDecimals: number,
  number: number,
};

const trimExtraDecimals = (number: number, max: number = 1) => {
  const numberString = `${number}`;
  const dotIndex = numberString.indexOf('.');
  return dotIndex > -1
    ? numberString.slice(0, dotIndex + max + 1)
    : numberString;
};

const abbreviateNumber = (number: number, maxDecimals: number) => {
  if (number < 10000) {
    return number;
  }
  if (number < 1e6) {
    return `${trimExtraDecimals(number / 1000, maxDecimals)}K`;
  }
  // Only go up to millions for now
  return `${trimExtraDecimals(number / 1e6, maxDecimals)}M`;
};

const AbbreviatedNumber = ({ maxDecimals, number }: AbbreviatedNumberProps) => {
  const abbreviatedNumber = abbreviateNumber(number, maxDecimals);
  const isAbbreviated = abbreviatedNumber !== number;
  const HtmlTag = isAbbreviated ? 'abbr' : 'span';
  const title = isAbbreviated ? number.toLocaleString() : null;
  return (
    <HtmlTag className={bem()} title={title}>
      {abbreviatedNumber}
    </HtmlTag>
  );
};

AbbreviatedNumber.defaultProps = {
  maxDecimals: 1,
  number: 0,
};

export default AbbreviatedNumber;
